import wc from "@/assets/gallery/WildcardVuota.webp";
export default function Marquee({
  text = "BREAK THE RULES",
  variant = "outline",
  separator = "⬡",
}) {
  const repeated = Array.from({ length: 8 }).fill(text);

  const klass =
    variant === "outline"
      ? "text-outline"
      : variant === "solid"
        ? "text-white"
        : "text-[#FF4500]";

  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-[#2A2A2A] bg-[#050505] py-6 select-none"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {repeated.concat(repeated).map((t, i) => (
          <span
            key={i}
            className={`font-bebas text-6xl md:text-8xl uppercase mx-6 ${klass}`}
          >
            {t} <span className="text-[#FF4500] mx-4">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
}